import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

import { useVersionCheck } from '../hooks/useVersionCheck';

/**
 * Thin bar shown once a newer build is deployed. The tab also reloads on its
 * own at the next safe moment (see useVersionCheck); this lets the user do it
 * now.
 */
export function UpdateAvailableBanner() {
  const { t } = useTranslation();
  const { stale, reload } = useVersionCheck();
  if (!stale) return null;
  return (
    <div
      role="status"
      data-testid="update-available-banner"
      className="flex shrink-0 items-center justify-center gap-3 bg-[var(--color-accent-subtle)] px-4 py-1.5 text-sm text-[var(--color-accent)]"
    >
      <Icon icon="mdi:refresh" className="size-4 shrink-0" />
      <span>{t('core.updateBanner.message')}</span>
      <button
        type="button"
        onClick={reload}
        className="cursor-pointer rounded-md border border-[var(--color-accent)]/30 px-2.5 py-0.5 text-xs font-semibold hover:bg-[var(--color-accent)]/10"
      >
        {t('core.updateBanner.reload')}
      </button>
    </div>
  );
}
